import { render } from "./LiveGrid.vue?vue&type=template&id=21bebf3b&scoped=true"
import script from "./LiveGrid.vue?vue&type=script&lang=js"
export * from "./LiveGrid.vue?vue&type=script&lang=js"

import "./LiveGrid.vue?vue&type=style&index=0&id=21bebf3b&scoped=true&lang=scss"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21bebf3b"]])

export default __exports__